// extracted by mini-css-extract-plugin
export default {"notificationBadge":"NotificationBadge_notificationBadge__pP2Ob","message":"NotificationBadge_message__ePkIH","notificationIcon":"NotificationBadge_notificationIcon__xvHn-"};